import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CoreActionCreatorService } from '@ispm/core/services/core-action-creator.service';
import { DiagnosticOrderActionsService } from '@ispm/dashboard/test/services/diagnostic-order-actions.service';
import { ActivityService } from '@ispm/user/services/activity.service';
import { NotesService } from '@ispm/user/services/notes.service';
import _ from 'lodash';
import { ScrollGlueDirective } from './scroll-glue-migrated.directive';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';
import {ActivityActions} from "@ispm/user/constants/activityActions";

@Component({
  selector: 'gen-notes-side-panel',
  templateUrl: './notes-side-panel.component.html',
  styleUrls: ['./notes-side-panel.component.scss']
})
export class NotesSidePanelComponent {

  @Input() contextId: string;
  @Input() contextType: string;
  @Input() actorId: string;
  @Input() actorType: string;
  @Input() newNotes: any;
  @Input() contextObject: any;
  @Output() newNotesChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(ScrollGlueDirective) scroll: ScrollGlueDirective;
  notes: any;
  dashboardLoading: any;
  notesFilter: string;
  text: string;
  addNoteButtonChange: Boolean = true;
  textValue: string;
  constructor(
    public notesService: NotesService,
    private _diagnosticOrderActionsService: DiagnosticOrderActionsService,
    private _activityService: ActivityService,
    private changeDetector: ChangeDetectorRef,
    private coreActionCreatorService: CoreActionCreatorService,
    private notificationMessageService: NotificationMessageService
  ) {
  }
  ngOnInit() {
    this.notesFilter = 'all';
    this.notesService.notePanelIsOpened = false;
    this._diagnosticOrderActionsService.getState()
      .take(1)
      .toPromise()
      .then(state => {
        state.order;
        this.init();
      });
    this.changeDetector.detectChanges();
  }

  init() {
    this.notesService.notePanelIsOpened = false;

    this.notesService.get(this.contextId, this.actorId).subscribe((res) => {
      const resultbody = res.body;
      const result = resultbody.sort((a, b) => new Date(a.meta['lastUpdated']).getTime() - new Date(b.meta['lastUpdated']).getTime());
      if (res) {
        this.notes = result;
        this._diagnosticOrderActionsService.updateNotes(this.notes.length);
        this._diagnosticOrderActionsService.currentNotes(this.notes); // passing the notes values
        this.newNotesChange.emit(this.notes);
      }
    });
  }
  valueChangeEvent(val: string) {
    this.textValue = val ? val.replace(/<[^>]*>/g, '').trim() : '';
    this.addNoteButtonChange = this.textValue.length === 0;
    this.setNotesRead();
    this.changeDetector.markForCheck();
    this.changeDetector.detectChanges();
  }
  public postNote() {
    this.coreActionCreatorService.setLoader(true);
    const note = {
      actor: {
        reference: this.actorId,
        resourceType: this.actorType
      },
      context: this.contextObject,
      text: this.text,
      parentNote: null
    };

    this.dashboardLoading = this.notesService.save(note)
      .then((res) => {
        this._activityService.create(
          {
            actor: {
              reference: res.body.actor.id,
              resourceType: res.body.actor.resourceType
            },
            context: [{
              reference: res.body.id,
              resourceType: 'Note'
            }],
            action: ActivityActions.READ
          }).subscribe(() => {

          });
        res.body.read = true;
        this.notes.push(res.body);
        this._diagnosticOrderActionsService.updateNotes(this.notes.length);
        this.coreActionCreatorService.setLoader(false);
        this.notes = [...this.notes];
        this.text = '';
        this.changeDetector.detectChanges();
      })
      .catch(err => {
        if (err.status === 400) {
          this.notificationMessageService.error(err.data);
        }
      });
  }
  setNotesRead() {
    const activities = [];
    _.each(this.notes, (note) => {
      if (!note.read) {
        activities.push(
          {
            actor: {
              reference: this.actorId,
              resourceType: note.actor.resourceType
            },
            context: [{
              reference: note.id,
              resourceType: 'Note'
            }],
            action: 'read'
          }
        );
      }
    });

    if (activities.length > 0) {
      this._activityService.create(activities)
        .subscribe(() => this.setNotesUIRead());
    }
  }
  setNotesUIRead() {
    _.each(this.notes, (note) => {
      note.read = true;
    });
  }

}
